"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiErrorType = exports.ApiErrorCode = void 0;
var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode["UNKNOWN"] = "UNKNOWN";
    ApiErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ApiErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ApiErrorCode["MISSING_PARAM"] = "MISSING_PARAM";
    ApiErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ApiErrorCode["ERR_BAD_REQUEST"] = "ERR_BAD_REQUEST";
    ApiErrorCode["INVALID_CAPTCHA"] = "INVALID_CAPTCHA";
    ApiErrorCode["EMPTY_RESPONSE"] = "EMPTY_RESPONSE";
    ApiErrorCode["DECODDING_ERROR"] = "DECODDING_ERROR";
    ApiErrorCode["ENCODDING_ERROR"] = "ENCODDING_ERROR";
    ApiErrorCode["INVALID_EMAIL"] = "INVALID_EMAIL";
    ApiErrorCode["NO_CHANGE"] = "NO_CHANGE";
    ApiErrorCode["INVALID_CSS_CARD_ID"] = "INVALID_CSS_CARD_ID";
    ApiErrorCode["EXPIRED_TOKEN"] = "EXPIRED_TOKEN";
    ApiErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
    ApiErrorCode["ALREADY_REGISTERED"] = "ALREADY_REGISTERED";
    ApiErrorCode["WEAK_PASSWORD"] = "WEAK_PASSWORD";
    ApiErrorCode["INVALID_CREDENTIALS"] = "InvalidCredentials";
    ApiErrorCode["SERVER_ERROR"] = "ServerError";
})(ApiErrorCode || (exports.ApiErrorCode = ApiErrorCode = {}));
var ApiErrorType;
(function (ApiErrorType) {
    ApiErrorType["Unexpected"] = "Unexpected Error";
    ApiErrorType["Expected"] = "Expected Error";
})(ApiErrorType || (exports.ApiErrorType = ApiErrorType = {}));
//# sourceMappingURL=errors.js.map